module.exports = __webpack_public_path__ + "abf8c2db2d0c462e1f4d7feeb5b04b5e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/up-24.png
// module id = 2636
// module chunks = 0